import * as React from 'react';
import "react-datepicker/dist/react-datepicker.css";
import BarChart from '../Bar';
import Chart from '../Chart';
import Column from '../Column';
import List from '../List';
import Frame from '../Frame';
import IFrame from '../IFrame';
import Pie from '../Pie';
import Column_Pie from '../Column_Pie';
import Bar_List from '../BarList';
import MultiBar_List from '../MultiAxisBar_List';
import Line_List from '../LineList';
import moment from 'moment';
import $ from 'jquery';
import Claim from '../Claim';
import Claim_New from '../Claim_New';
import FilterTagCom from '../FilterTag';
import { userService } from '../../_services';
import { Redirect } from "react-router-dom";
import ColorJson from '../../../src/whitelabel.json';

class DistributorDashboard extends React.Component {
    constructor(props) {
        super(props);
        var startdate = new Date();
        startdate.setDate(startdate.getDate() - 30);
        var enddate = new Date();
        if (localStorage.getItem('User_Start_Date') != "" && localStorage.getItem('User_Start_Date') != null && localStorage.getItem('User_Start_Date') != undefined) {
            startdate = localStorage.getItem('User_Start_Date');
        }
        if (localStorage.getItem('User_End_Date') != "" && localStorage.getItem('User_End_Date') != null && localStorage.getItem('User_End_Date') != undefined) {
            enddate = localStorage.getItem('User_End_Date');
        }
        let filterdatalocal = localStorage.getItem('Advance_Filter');
        if (filterdatalocal == null || filterdatalocal == '' || filterdatalocal == undefined || filterdatalocal == "null") {
            filterdatalocal = '';
        }

        var _roletype = '', _rolename = '';
        var _wh_Id = 0;
        var _Distributor_UserId = 0;

        try {
            var userdata = JSON.parse(localStorage.getItem('user'));
            try { _Distributor_UserId = userdata.distributor_UserId; }
            catch (error) { }
            if (userdata.userrole == "Distributor" && userdata.wholesaler == "Avenel_lll") {
                _roletype = "avdistributor";
                _rolename = userdata.email;
                _wh_Id = userdata.wholesaler_Id;
            }
            else if (userdata.userrole == "Distributor" && userdata.wholesaler != "Avenel_lll") {
                _roletype = "distributor";
                _rolename = userdata.paramsname;
                _wh_Id = userdata.wholesaler_Id;
            }
            else {
                _roletype = userdata.userrole;
                _rolename = userdata.paramsname;
                _wh_Id = userdata.wholesaler_Id;
            }
        }
        catch (error) { }
        this.state = {
            userdata: JSON.parse(localStorage.getItem('user')),
            scrollArray: {},
            graphData: [],
            dashboardName: this.props.dashboardName,
            wholesalerName: this.props.Wholesaler,
            DistributorEmail: this.props.DisEmail,
            IframeBaseURL: "",
            endDate: new moment(enddate).format("YYYYMMDD"),
            startDate: new moment(startdate).format("YYYYMMDD"),
            FilterTagMatch: [],
            FilterTagList: filterdatalocal,
            roletype: _roletype,
            rolename: _rolename,
            wh_Id: _wh_Id,
            distributor_UserId: _Distributor_UserId,
            dist_usertype: this.props.dist_usertype
        };
        let newDate = new Date();
        localStorage.setItem('Filter_Last_Update_Time', newDate);
        this.handlechangea = this.handlechangea.bind(this);
        this.changeData();
    }
    componentDidMount() {
        this.changeData();
        setTimeout(function () {
            var $head = $(".widget-iframe").contents().find("head");
            var $body = $(".widget-iframe").contents().find("body");
            $head.append($("<link/>",
                { rel: "stylesheet", href: "/table.css", type: "text/css" }));
            if ($(window).width() < 480) {
                $body.addClass('scrollMobile');
            } else {
                $body.removeClass('scrollMobile');
            }

        }, 1000);

        $(window).resize(function () {
            var $body = $(".widget-iframe").contents().find("body");
            if ($(window).width() < 480) {
                $body.addClass('scrollMobile');
            } else {
                $body.removeClass('scrollMobile');
            }
        });
    }
    componentDidUpdate() {
        if (this.state.dist_usertype != this.props.dist_usertype) {
            this.setState({
                dist_usertype: this.props.dist_usertype
            });
            localStorage.setItem('dist_usertype', this.props.dist_usertype);
            this.changeData();
        }
    }
    handlechangea(e) {
        this.props.handeChangefilter(e);
    }
    handleCollapse = () => {
        if ($(".sidebar-section").hasClass("intro")) {
            $(".menu-text").css('width', 'auto');
            $(".sidebar-section").animate({
                width: 270 + 'px'
            }, 1000);
            $(".collapseButton").animate({
                left: 246 + 'px'
            }, 1000, function () {
                $("#chartjs-tooltip").hide();
                $(".collapseButton").removeClass('active');
                $(".tierMilestone .range").removeClass('active');
            });
            $(".dashboardHeading").animate({
                marginLeft: 313 + 'px'
            }, 400);
            $("#dashboard_header_select").animate({
                marginLeft: 0 + 'px'
            }, 1000);
            $("#dashboard-container").animate({
                marginLeft: 13 + 'px'
            }, 1000);
            $(".adjustWidth").css('margin', '0 0 0 65px');
            $(".sidebar-section").removeClass('intro');
            $(".react-bootstrap-daterangepicker-container").animate({
                marginRight: 0 + 'px'
            }, 1000);
            $("#dashboard_header_select").removeClass('full');
        } else {
            $(".sidebar-section").animate({
                width: 90 + 'px'
            }, 1000, function () {
                $(".menu-text").css('width', '0px');
            });
            $(".collapseButton").animate({
                left: 66 + 'px'
            }, 1000, function () {
                $(".collapseButton").addClass('active');
                $(".tierMilestone .range").addClass('active');
            });
            $(".dashboardHeading").animate({
                marginLeft: 140 + 'px'
            }, 400);
            $("#dashboard_header_select").animate({
                marginLeft: -173 + 'px'
            }, 1000);
            $("#dashboard-container").animate({
                marginLeft: -158 + 'px'
            }, 1000);
            $(".adjustWidth").css('margin', '0 auto');
            $(".sidebar-section").addClass('intro');
            $(".react-bootstrap-daterangepicker-container").animate({
                marginRight: -173 + 'px'
            }, 1000, function () {
                $("#dashboard_header_select").addClass('full');
            });
        }
        var $head8 = $(".widget-iframe").contents().find("head");
        $head8.append($("<link/>",
            { rel: "stylesheet", href: "/table.css", type: "text/css" }));
    }

    changeData() {
        var APIBaseURL = "";
        var IframeBase = "";
        var wname = this.props.dashboardName;
        var startDateObj = this.props.startDate;
        var endDateObj = this.props.endDate;
        var startDate = new moment(startDateObj).format("YYYYMMDD");
        var endDate = new moment(endDateObj).format("YYYYMMDD");
        this.setState({ startDate: startDate });
        this.setState({ endDate: endDate });
        var wholesalername = this.props.Wholesaler;
        var disemail = this.props.DisEmail;
        var AllDirectOverride = this.props.dist_usertype; //this.props.handlechangealldirectoverride;
        if (wname == null || wname == '') {
            wname = this.props.DisName;
        }
        if (wholesalername == 'Avenel_llll') {
            wname = disemail;
            // APIBaseURL = 'https://cnd.23byt.es/avds/';
            //this.state.IframeBaseURL = "http://hd.cyfe.23byt.es/avds?sname=" + wname;
            APIBaseURL = '/api/avds';
        } else {
            //APIBaseURL = 'https://cnd.23byt.es/ds/';
            //this.state.IframeBaseURL = "https://cnd.23byt.es/ds?sname=" + escape(wname.replace(" Dashboard", "").trim());
            if (AllDirectOverride === 'All')
                APIBaseURL = '/api/distsubdist_All';
            else if (AllDirectOverride === 'Direct')
                APIBaseURL = '/api/ds';
            else if (AllDirectOverride === 'Override')
                APIBaseURL = '/api/distsubdist';
            else
                APIBaseURL = '/api/ds';
        }
        let newDate = new Date();
        try {
            newDate = localStorage.getItem('Updated_Filter_Status');
        }
        catch (error) {
        }
        var AdFilterJson = '';

        try {
            AdFilterJson = JSON.parse(localStorage.getItem('Advance_Filter'))
            if (AdFilterJson != null && AdFilterJson != '' && AdFilterJson != undefined && AdFilterJson != "null") {
                this.setState({ FilterTagList: JSON.stringify(AdFilterJson) });
            }
            else {
                this.setState({ FilterTagList: '' });
            }
        }
        catch (error) {
            this.setState({ FilterTagList: '' });
        }
        var Request_user = escape(wname.replace(" Dashboard", "").trim());
        var Column_PostData_RequestJson = "{\"wname\"" + ":\"" + this.state.userdata["distributor_UserId"] + "\",\"whname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 30 + ",\"chart_type\"" + ":\"" + "columnList\"" + ",\"ispatientsaving\"" + ":\"" + "true\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\"}";
        var MultiAxis_Column_PostData_RequestJson = "{\"wname\"" + ":\"" + this.state.userdata["distributor_UserId"] + "\",\"whname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 0 + ",\"chart_type\"" + ":\"" + "column_multiaxislist\"" + ",\"ispatientsaving\"" + ":\"" + "true\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\"}";
        var PostData_PatientSaving_True = "{\"wname\"" + ":\"" + this.state.userdata["distributor_UserId"] + "\",\"whname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 30 + ",\"chart_type\"" + ":\"" + "lineList\"" + ",\"ispatientsaving\"" + ":\"" + "true\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\"}";
        var PostData_PatientSaving_False = "{\"wname\"" + ":\"" + this.state.userdata["distributor_UserId"] + "\",\"whname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 30 + ",\"chart_type\"" + ":\"" + "lineList\"" + ",\"ispatientsaving\"" + ":\"" + "false\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\"}";
        var PostData_RequestJson = "{\"wname\"" + ":\"" + this.state.userdata["distributor_UserId"] + "\",\"whname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 30 + ",\"chart_type\"" + ":\"" + "pielist\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\"}";
        var Drug_Transaction_PostData_RequestJson = "{\"wname\"" + ":\"" + this.state.userdata["distributor_UserId"] + "\",\"whname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 30 + ",\"chart_type\"" + ":\"" + "list\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\"}";
        var PatientSavings_Pharmacy_RequestJson = "{\"wname\"" + ":\"" + this.state.userdata["distributor_UserId"] + "\",\"whname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 30 + ",\"chart_type\"" + ":\"" + "list\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\"}";
        var Table_Pharmacy_RequestJson = "{\"wname\"" + ":\"" + this.state.userdata["distributor_UserId"] + "\",\"whname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 30 + ",\"chart_type\"" + ":\"" + "list\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\"}";
        var TotalTransaction_PostData_RequestJson = "{\"wname\"" + ":\"" + this.state.userdata["distributor_UserId"] + "\",\"whname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 0 + ",\"chart_type\"" + ":\"" + "columnList\"" + ",\"ispatientsaving\"" + ":\"" + "true\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\"}";
        var Claim_PostData_RequestJson = "{\"wname\"" + ":\"" + this.state.userdata["distributor_UserId"] + "\",\"whname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 0 + ",\"chart_type\"" + ":\"" + "list\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\"}";
        var primaryColor;
        var secondaryColor;
        var extraColor;
        if (window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com") {
            primaryColor = ColorJson.ApplicationColor.Rxhacker_primary_color;
            secondaryColor = ColorJson.ApplicationColor.Rxhacker_secondary_color;
            extraColor = ColorJson.ApplicationColor.Rxhacker_extra_color;
        } else {
            primaryColor = ColorJson.ApplicationColor.Glic_primary_color;
            secondaryColor = ColorJson.ApplicationColor.Glic_secondary_color;
            extraColor = ColorJson.ApplicationColor.Glic_extra_color;
        }

        this.setState({
            dashboardName: wname,
            graphData: [
                {
                    // url: APIBaseURL + "/totaltransaction?wname=" + escape(wname.replace(" Dashboard", "").trim()) + "&start_date=" + startDate + "&end_date=" + endDate,
                    url: APIBaseURL + "/total_transactions_new",
                    type: "Bar_List",
                    title: "Total Transactions",
                    Subtitle: "Total number of transactions for each day",
                    ColorCode: secondaryColor,
                    DataType: "NA",
                    XlabelString: "Date",
                    YlabelString: "# of Transactions",
                    interval: 'day',
                    id: "DTotalTransaction",
                    BorderRadius: 0,
                    RequestJson: TotalTransaction_PostData_RequestJson,
                    RequestJson1: JSON.stringify(AdFilterJson)
                },
                {
                    url: APIBaseURL + "/ClaimCalculation",
                    type: "Claim",
                    title: "Claim Counts",
                    Subtitle: "",
                    ColorCode: extraColor,
                    id: "RxSensClaim",
                    RequestJson: Claim_PostData_RequestJson,
                    RequestJson1: JSON.stringify(AdFilterJson)
                },
                //{
                //    url: APIBaseURL + "/ClaimCalculation_New",
                //    type: "Claim_New",
                //    title: "Claim Counts",
                //    Subtitle: "",
                //    ColorCode: "#ffba10",
                //    id: "RxSensClaimNew",
                //    RequestJson: Claim_PostData_RequestJson,
                //    RequestJson1: JSON.stringify(AdFilterJson)
                //},
                {
                    //url: APIBaseURL + "metric1a?wname=" + escape(wname.replace(" Dashboard", "").trim()) + "&start_date=" + startDate + "&end_date=" + endDate,
                    url: APIBaseURL + "/metric1a_new",
                    type: "Bar_List",
                    title: "Transactions by Group Number",
                    Subtitle: "Number of transactions for each group number",
                    ColorCode: secondaryColor,
                    DataType: "GroupNumber",
                    XlabelString: "Group Number",
                    YlabelString: "# of Transactions",
                    id: "DMetric1a",
                    BorderRadius: 10,
                    RequestJson: Column_PostData_RequestJson,
                    RequestJson1: JSON.stringify(AdFilterJson)
                },
                {
                    //url: APIBaseURL + "metric1b?wname=" + escape(wname.replace(" Dashboard", "").trim()) + "&ispatientsaving=true&pharmacynumber=all&start_date=" + startDate + "&end_date=" + endDate,
                    url: APIBaseURL + "/patient_savings_new",
                    type: "Line_List",
                    title: "Average Patient Savings ($)",
                    Subtitle: "Average savings for all patients in $",
                    ColorCode: secondaryColor,
                    XlabelString: "",
                    YlabelString: "Average Saving",
                    id: "DMetric3A",
                    BorderRadius: 0,
                    RequestJson: PostData_PatientSaving_True,
                    RequestJson1: JSON.stringify(AdFilterJson)
                },
                {
                    //url: APIBaseURL + "metric1b?wname=" + escape(wname.replace(" Dashboard", "").trim()) + "&ispatientsaving=false&pharmacynumber=all&start_date=" + startDate + "&end_date=" + endDate,
                    url: APIBaseURL + "/patient_savings_new",
                    type: "Line_List",
                    title: "Average Patient Savings (%)",
                    Subtitle: "Average savings for all patients in %",
                    ColorCode: secondaryColor,
                    XlabelString: "",
                    YlabelString: "Average Saving",
                    id: "DMetric3B",
                    BorderRadius: 0,
                    RequestJson: PostData_PatientSaving_False,
                    RequestJson1: JSON.stringify(AdFilterJson)
                },
                //{
                //    //url: APIBaseURL + "top20pharmacy?wname=" + escape(wname.replace(" Dashboard", "").trim()) + "&start_date=" + startDate + "&end_date=" + endDate,
                //    url: APIBaseURL + "/top20avgsavingspharmacy_new",
                //    type: "Column_Pie",
                //    title: "Average Patient Savings at Top 20 Pharmacies",
                //    Subtitle: "Shows the average savings at the top 20 pharmacies",
                //    ColorCode: "#ffba10",
                //    XlabelString: "Pharmacy",
                //    YlabelString: "Average Saving",
                //    id: "DTop20pharmacy",
                //    BorderRadius: 0,
                //    RequestJson: PostData_RequestJson
                //},
                {
                    //url: APIBaseURL + "statetransaction?wname=" + escape(wname.replace(" Dashboard", "").trim()) + "&start_date=" + startDate + "&end_date=" + endDate,
                    url: APIBaseURL + "/statetransaction_new",
                    type: "Column_Pie",
                    title: "Transactions by State",
                    Subtitle: "Number of transactions in each state",
                    ColorCode: "#0282fb",
                    DataType: "PhState",
                    XlabelString: "States",
                    YlabelString: "Number of Transactions",
                    id: "DStateTransaction",
                    BorderRadius: 0,
                    RequestJson: PostData_RequestJson,
                    RequestJson1: JSON.stringify(AdFilterJson)
                },


                {
                    //url: APIBaseURL + "pharmacytransaction1?wname=" + escape(wname.replace(" Dashboard", "").trim()) + "&start_date=" + startDate + "&end_date=" + endDate,
                    url: APIBaseURL + "/pharmacy_transaction_new",
                    type: "List",
                    title: "Transactions by Pharmacy",
                    Subtitle: "Number of transactions at each pharmacy",
                    ColorCode: "",
                    XlabelString: "",
                    YlabelString: "",
                    id: "DPharmacyTransaction1",
                    BorderRadius: 0,
                    RequestJson: Table_Pharmacy_RequestJson,
                    RequestJson1: JSON.stringify(AdFilterJson)
                },
                {
                    //url: APIBaseURL + "drugtransaction?wname=" + escape(wname.replace(" Dashboard", "").trim()) + "&start_date=" + startDate + "&end_date=" + endDate,
                    url: APIBaseURL + "/drugtransaction_new",
                    type: "List",
                    title: "Transactions by Drug",
                    Subtitle: "Number of transactions for each drug",
                    ColorCode: "",
                    XlabelString: "",
                    YlabelString: "",
                    id: "DDrugTransaction",
                    BorderRadius: 0,
                    RequestJson: Drug_Transaction_PostData_RequestJson,
                    RequestJson1: JSON.stringify(AdFilterJson)
                },
                {
                    //url: APIBaseURL + "commission?wname=" + escape(wname.replace(" Dashboard", "").trim()),
                    url: APIBaseURL + "/commission_new",
                    type: "Bar_List",
                    title: "Total Commission Earned",
                    Subtitle: "Commission earned for each month",
                    ColorCode: secondaryColor,
                    DataType: "NA",
                    interval: 'month',
                    XlabelString: "Date",
                    YlabelString: "Commission",
                    id: "DCommission",
                    BorderRadius: 0,
                    RequestJson: Column_PostData_RequestJson,
                    RequestJson1: JSON.stringify(AdFilterJson)
                },
                {
                    //url: APIBaseURL + "commission?wname=" + escape(wname.replace(" Dashboard", "").trim()),
                    url: APIBaseURL + "/commission_new1",
                    type: "MultiBar_List",
                    title: "Total Commission Earned",
                    Subtitle: "Commission earned for each month",
                    ColorCode: primaryColor,
                    interval: 'month',
                    XlabelString: "Date",
                    YlabelString: "Commission",
                    id: "DCommission1",
                    BorderRadius: 0,
                    RequestJson: MultiAxis_Column_PostData_RequestJson,
                    RequestJson1: JSON.stringify(AdFilterJson)
                },
                {
                    //url:APIBaseURL + "wholesalertransaction?wholesaler=" + escape(wname.replace(" Dashboard", "").trim()) + "&start_date=" + startDate + "&end_date=" + endDate + "&role=distributor",
                    url: APIBaseURL + "/wholesalertransaction_new",
                    type: "List",
                    title: "Transactions (Sub-Distributors)",
                    Subtitle: "Transactions including sub-distributors",
                    XlabelString: "",
                    YlabelString: "",
                    ColorCode: "",
                    id: "DTransactions",
                    BorderRadius: 0,
                    RequestJson: Table_Pharmacy_RequestJson,
                    RequestJson1: JSON.stringify(AdFilterJson)
                },
                {
                    //url: APIBaseURL + "ws/pharmacytransaction1?wname=" + escape(wname.replace(" Dashboard (wholesaler)", "").trim()) + "&start_date=" + startDate + "&end_date=" + endDate,
                    url: APIBaseURL + "/prescribe_transaction_new",
                    type: "List",
                    title: "Transactions by Prescriber",
                    Subtitle: "Number of transactions at each Prescriber",
                    ColorCode: extraColor,
                    XlabelString: "",
                    YlabelString: "",
                    id: "WPrescriberTransaction1",
                    RequestJson: Table_Pharmacy_RequestJson,
                    RequestJson1: JSON.stringify(AdFilterJson)
                },
                {
                    //url: APIBaseURL + "patientsavingtransaction?wname=" + escape(wname.replace(" Dashboard", "").trim()) + "&start_date=" + startDate + "&end_date=" + endDate,
                    url: APIBaseURL + "/patientsavings_new",
                    type: "List",
                    title: "Patient Savings by Pharmacy",
                    Subtitle: "Patient savings in $ at each pharmacy",
                    ColorCode: "",
                    XlabelString: "",
                    YlabelString: "",
                    id: "DPatientSavingTransaction",
                    BorderRadius: 0,
                    RequestJson: PatientSavings_Pharmacy_RequestJson,
                    RequestJson1: JSON.stringify(AdFilterJson)
                },
                {
                    //url: APIBaseURL + "ws/pharmacytransaction1?wname=" + escape(wname.replace(" Dashboard (wholesaler)", "").trim()) + "&start_date=" + startDate + "&end_date=" + endDate,
                    url: APIBaseURL + "/Repeat_Prescriptions_transaction_new",
                    type: "List",
                    title: "Transactions by Repeat Prescriptions",
                    Subtitle: "Number of repeat prescriptions by each Prescriber",
                    ColorCode: extraColor,
                    XlabelString: "",
                    YlabelString: "",
                    id: "WRepeat_PrescriptionsTransaction",
                    RequestJson: Table_Pharmacy_RequestJson,
                    RequestJson1: JSON.stringify(AdFilterJson)
                }
            ]
        });
    }

    render() {
        var startDateObj = this.props.startDate;
        var startDate = new moment(startDateObj).format("YYYYMMDD");
        var endDateObj = this.props.endDate;
        var endDate = new moment(endDateObj).format("YYYYMMDD");
        var IsCall = false;
        //try {
        //    if (localStorage.getItem('Prev_Filter_Status').toLowerCase() != localStorage.getItem('Updated_Filter_Status').toLowerCase()) {
        //        IsCall = true;
        //    }
        //    else {
        //        IsCall = false;
        //    }
        //}
        //catch (error) {
        //    IsCall = false;
        //}
        //try {
        //    if (endDate != this.state.endDate || startDate != this.state.startDate || IsCall == true) {
        //        if (IsCall == true) {
        //            localStorage.setItem('Prev_Filter_Status', localStorage.getItem('Updated_Filter_Status'));
        //        }
        //        this.changeData();
        //    }
        //} catch (error) {
        //}
        try {
            if ((localStorage.getItem('Prev_Filter_Status').toLowerCase() != localStorage.getItem('Updated_Filter_Status').toLowerCase()) || (localStorage.getItem('Prev_AdFilter_Status') != localStorage.getItem('Updated_AdFilter_Status')) || (localStorage.getItem('Updated_HD_Type') != localStorage.getItem('Prev_HD_Type'))) {
                IsCall = true;
            }
            else {
                IsCall = false;
            }
        }
        catch (error) {
            IsCall = false;
        }
        try {
            if (endDate != this.state.endDate || startDate != this.state.startDate || IsCall == true) {
                if (IsCall == true) {
                    localStorage.setItem('Prev_Filter_Status', localStorage.getItem('Updated_Filter_Status'));
                    if (localStorage.getItem('Updated_AdFilter_Status') == "null" || localStorage.getItem('Updated_AdFilter_Status') == null) {
                        localStorage.setItem('Prev_AdFilter_Status', null);
                        localStorage.setItem('Updated_AdFilter_Status', null);
                    }
                    else {
                        localStorage.setItem('Prev_AdFilter_Status', localStorage.getItem('Updated_AdFilter_Status'));
                    }
                    if (localStorage.getItem('Updated_HD_Type') == "null" || localStorage.getItem('Updated_HD_Type') == null) {
                        localStorage.setItem('Prev_HD_Type', null);
                        localStorage.setItem('Updated_HD_Type', null);
                    }
                    else {
                        localStorage.setItem('Prev_HD_Type', localStorage.getItem('Updated_HD_Type'));
                    }
                }
                this.changeData();
            }
        } catch (error) {
        }
        const a = [];
        // eslint-disable-next-line no-unused-expressions
        a[0] = { height: 570, width: 1100 },
            a[1] = { height: 170, width: 550 },
            a[2] = { height: 170, width: 550 }

        try {
            let usertype = userService.Get_User_Type();
            if (userService.Check_LoggedIn_Status() == 'Login') {
                return <Redirect to="/login" />
            }
            if (usertype.toLowerCase() == 'wholesaler') {
                return <Redirect to='/pageNotFound' />
            }
            else if (usertype.toLowerCase() == 'admin') {
                return <Redirect to='/pageNotFound' />
            }
            else if (usertype.toLowerCase() == 'subadmin') {
                return <Redirect to='/pageNotFound' />
            }
        } catch (error) { }
        return (
            <div className="dashboard-content-parent">
                <div className="newBoard">
                    <div className="parent">
                        <div className="contentContainer">
                            <div>
                                <div className='row'>
                                    <div className='double-column'>
                                        <div className="dashboard-container" id="dashboard-container">
                                            <a href="javascript:void('0')" className="collapseButton" onClick={this.handleCollapse}>Collapse Button</a>
                                            <FilterTagCom dist_id={this.state.distributor_UserId} Rolename={this.state.rolename} wh_Id={this.state.wh_Id} Roletype={this.state.roletype} df={this.state.startDate} dt={this.state.endDate} handlechangea={this.handlechangea} FilterTags={this.state.FilterTagList} />
                                            {
                                                this.state.graphData.map((item, index) => {
                                                    return (
                                                        (
                                                            (this.state.wholesalerName.toLowerCase() == 'Avenel_llll' && item.title == 'Total Commission Earned' && item.type == "MultiBar_List")
                                                            || (this.state.wholesalerName.toLowerCase() != 'Avenel_llll' && item.title == 'Total Commission Earned' && item.type == "Bar_List")
                                                            || ((this.state.userdata.wholesaler.toLowerCase() == 'trustcare health, llc' && item.id == 'WPrescriberTransaction1') || (this.state.userdata.wholesaler.toLowerCase() == 'trustcare health, llc' && item.id == 'WRepeat_PrescriptionsTransaction'))
                                                            || ((this.state.userdata.wholesaler.toLowerCase() == 'medresults, llc' && item.id == 'WPrescriberTransaction1') || (this.state.userdata.wholesaler.toLowerCase() == 'medresults, llc' && item.id == 'WRepeat_PrescriptionsTransaction'))
                                                        ) ? null :
                                                            <div id={item.id + index} className={`${item.type == "Bar" ? "widget ui-draggable ui-resizable" : item.type == "Line" ? "widget ui-draggable ui-resizable second" : "widget ui-draggable ui-resizable customScroll third"}${item.id == "DTransactions" ? ' full-layout list' : ''}${item.id == "RxSensClaim" ? ' full-layout' : ''}${item.id == "RxSensClaimNew" ? ' full-layout' : ''}${item.id == "DPatientSavingTransaction" ? ' layout-not-margin list' : ''}${item.id == "WRepeat_PrescriptionsTransaction" ? ' layout-left-margin list' : ''}${item.id == "WPrescriberTransaction1" ? ' full-layout list' : ''}${item.id == "DPharmacyTransaction1" ? ' full-layout list' : ''}${item.id == "DTotalTransaction" ? ' full-layout barlist' : ''}${item.id == "DMetric1a" ? ' layout-not-margin barlist' : ''}${item.id == "DDrugTransaction" ? ' layout-not-margin list' : ''}${item.id == "DMetric3B" ? ' layout-not-margin barlist' : ''}${item.id == "DPatientSavingTransaction" ? ' layout-not-margin' : ''}${item.id == "DMetric3A" ? ' layout-left-margin barlist' : ''}${item.id == "DCommission" ? ' layout-left-margin barlist' : ''}${item.id == "DStateTransaction" ? ' layout-left-margin barlist' : ''}${item.id == "DCommission1" ? ' layout-left-margin barlist' : ''}`} key={"graph-widget" + index}>
                                                                <div className="widget-head" key={"graph-widget-head" + index}>
                                                                    <h3>
                                                                        <a data-original-title>{item.title}</a>
                                                                    </h3>
                                                                    <p>
                                                                        <a data-original-title>{item.Subtitle}</a>
                                                                    </p>
                                                                </div>
                                                                <div className="widget-content" key={"graph-widget-content" + index}>
                                                                    <div className="custom-scroll">
                                                                        <div className="scroll-content" style={{ height: this.state.scrollArray[this.state.graphData[index].id] }}>
                                                                            {item.type == "Bar" ? <BarChart data={item} key={"bargraph" + index} ColorCode={item.ColorCode} XlabelString={item.XlabelString} YlabelString={item.YlabelString} _Index={index} /> : null}
                                                                            {item.type == "Chart" || item.type == "Line" ? <Chart data={item} key={"linegraph" + index} XlabelString={item.XlabelString} YlabelString={item.YlabelString} _Index={index} /> : null}
                                                                            {item.type == "Column" ? <Column data={item} key={"columngraph" + index} XlabelString={item.XlabelString} YlabelString={item.YlabelString} _Index={index} /> : null}
                                                                            {item.type == "List" ? <List data={item} key={"listgraph" + index} _Index={index} handlechangea={this.handlechangea} /> : null}
                                                                            {item.type == "Pie" ? <Pie data={item} key={"piegraph" + index} _Index={index} /> : null}
                                                                            {item.type == "Column_Pie" ? <Column_Pie data={item} key={"columnpiegraph" + index} _Index={index} handlechangea={this.handlechangea} /> : null}
                                                                            {item.type == "Bar_List" ? <Bar_List data={item} key={"barlistgraph" + index} _Index={index} handlechangea={this.handlechangea} /> : null}
                                                                            {item.type == "Line_List" ? <Line_List data={item} key={"linelistgraph" + index} _Index={index} /> : null}
                                                                            {item.type == "MultiBar_List" ? <MultiBar_List data={item} key={"barlistgraph1" + index} _Index={index} /> : null}
                                                                            {item.type == "Claim" ? <Claim data={item} key={"claimbox" + index} _Index={index} /> : null}
                                                                            {item.type == "Claim_New" ? <Claim_New data={item} key={"claimboxnew" + index} _Index={index} /> : null}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="widget-foot">
                                                                    &nbsp;
                                                                        </div>
                                                            </div>
                                                    )
                                                })
                                            }

                                        </div>

                                    </div>
                                    <div className='column filter-section'>
                                        <div className="dashboard-container" id="dashboard-container">
                                            <IFrame url={this.state.IframeBaseURL} title="Filter" class="" />
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default DistributorDashboard;
